import React, { useEffect } from "react";
import "./WelcomeToast.css";

type Props = {
  open: boolean;
  title: string;
  message?: string;
  onClose: () => void;
};

export default function WelcomeToast({ open, title, message, onClose }: Props) {
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(onClose, 3200);
    return () => clearTimeout(t);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="toast" role="status" aria-live="polite">
      <div className="toast-text">
        <strong>{title}</strong>
        {message ? <div className="toast-sub">{message}</div> : null}
      </div>

      <button className="toast-close" onClick={onClose} aria-label="Sluiten">
        ✕
      </button>
    </div>
  );
}